export default __webpack_public_path__ + "static/media/AnimalMondey01_00.6d448f93.png";